import { render } from "./HelpActionButton.vue?vue&type=template&id=0a329ebe&scoped=true&ts=true"
import script from "./HelpActionButton.vue?vue&type=script&lang=ts"
export * from "./HelpActionButton.vue?vue&type=script&lang=ts"

import "./HelpActionButton.vue?vue&type=style&index=0&id=0a329ebe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a329ebe"]])

export default __exports__